/* eslint-disable */
import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {Deliveries, Delivery, DeliveryCreateReq, DeliveryUpdateReq} from '../types/delivery';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  IdRsp,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';

/**
 * DeliveryServiceApi - axios parameter creator
 * @export
 */
export const DeliveryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {DeliveryCreateReq} deliveryCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceCreate: async (
      deliveryCreateReq: DeliveryCreateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deliveryCreateReq' is not null or undefined
      assertParamExists('deliveryServiceCreate', 'deliveryCreateReq', deliveryCreateReq);
      const localVarPath = `/delivery/delivery`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deliveryCreateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('deliveryServiceDelete', 'id', id);
      const localVarPath = `/delivery/delivery/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceDetail: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('deliveryServiceDetail', 'id', id);
      const localVarPath = `/delivery/delivery/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {Array<string>} [apartmentIds]
     * @param {string} [name] search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceFind: async (
      orgId?: string,
      ids?: Array<string>,
      apartmentIds?: Array<string>,
      name?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/delivery/deliveries`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (ids) {
        localVarQueryParameter['ids'] = ids;
      }

      if (apartmentIds) {
        localVarQueryParameter['apartmentIds'] = apartmentIds;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {DeliveryUpdateReq} deliveryUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceUpdate: async (
      id: string,
      deliveryUpdateReq: DeliveryUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('deliveryServiceUpdate', 'id', id);
      // verify required parameter 'deliveryUpdateReq' is not null or undefined
      assertParamExists('deliveryServiceUpdate', 'deliveryUpdateReq', deliveryUpdateReq);
      const localVarPath = `/delivery/delivery/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deliveryUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DeliveryServiceApi - functional programming interface
 * @export
 */
export const DeliveryServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DeliveryServiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {DeliveryCreateReq} deliveryCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryServiceCreate(
      deliveryCreateReq: DeliveryCreateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryServiceCreate(
        deliveryCreateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryServiceApi.deliveryServiceCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryServiceApi.deliveryServiceDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Delivery>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryServiceDetail(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryServiceApi.deliveryServiceDetail']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {Array<string>} [apartmentIds]
     * @param {string} [name] search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryServiceFind(
      orgId?: string,
      ids?: Array<string>,
      apartmentIds?: Array<string>,
      name?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Deliveries>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryServiceFind(
        orgId,
        ids,
        apartmentIds,
        name,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryServiceApi.deliveryServiceFind']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {DeliveryUpdateReq} deliveryUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryServiceUpdate(
      id: string,
      deliveryUpdateReq: DeliveryUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryServiceUpdate(
        id,
        deliveryUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryServiceApi.deliveryServiceUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DeliveryServiceApi - factory interface
 * @export
 */
export const DeliveryServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DeliveryServiceApiFp(configuration);
  return {
    /**
     *
     * @param {DeliveryCreateReq} deliveryCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceCreate(
      deliveryCreateReq: DeliveryCreateReq,
      options?: any
    ): AxiosPromise<IdRsp> {
      return localVarFp
        .deliveryServiceCreate(deliveryCreateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .deliveryServiceDelete(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceDetail(id: string, options?: any): AxiosPromise<Delivery> {
      return localVarFp
        .deliveryServiceDetail(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {Array<string>} [apartmentIds]
     * @param {string} [name] search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceFind(
      orgId?: string,
      ids?: Array<string>,
      apartmentIds?: Array<string>,
      name?: string,
      options?: any
    ): AxiosPromise<Deliveries> {
      return localVarFp
        .deliveryServiceFind(orgId, ids, apartmentIds, name, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {DeliveryUpdateReq} deliveryUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryServiceUpdate(
      id: string,
      deliveryUpdateReq: DeliveryUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .deliveryServiceUpdate(id, deliveryUpdateReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * DeliveryServiceApi - object-oriented interface
 * @export
 * @class DeliveryServiceApi
 * @extends {BaseAPI}
 */
export class DeliveryServiceApi extends BaseAPI {
  /**
   *
   * @param {DeliveryCreateReq} deliveryCreateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryServiceApi
   */
  public deliveryServiceCreate(
    deliveryCreateReq: DeliveryCreateReq,
    options?: RawAxiosRequestConfig
  ) {
    return DeliveryServiceApiFp(this.configuration)
      .deliveryServiceCreate(deliveryCreateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryServiceApi
   */
  public deliveryServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return DeliveryServiceApiFp(this.configuration)
      .deliveryServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryServiceApi
   */
  public deliveryServiceDetail(id: string, options?: RawAxiosRequestConfig) {
    return DeliveryServiceApiFp(this.configuration)
      .deliveryServiceDetail(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [orgId]
   * @param {Array<string>} [ids]
   * @param {Array<string>} [apartmentIds]
   * @param {string} [name] search name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryServiceApi
   */
  public deliveryServiceFind(
    orgId?: string,
    ids?: Array<string>,
    apartmentIds?: Array<string>,
    name?: string,
    options?: RawAxiosRequestConfig
  ) {
    return DeliveryServiceApiFp(this.configuration)
      .deliveryServiceFind(orgId, ids, apartmentIds, name, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {DeliveryUpdateReq} deliveryUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryServiceApi
   */
  public deliveryServiceUpdate(
    id: string,
    deliveryUpdateReq: DeliveryUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return DeliveryServiceApiFp(this.configuration)
      .deliveryServiceUpdate(id, deliveryUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}
